import React from 'react';

const PreviewModal = ({ campaign, onClose }) => (
  <div className="gcd-modal-overlay" onClick={onClose}>
    <div className="gcd-preview-modal" onClick={(e) => e.stopPropagation()}>
      <div className="gcd-modal-header">
        <h2 className="gcd-modal-title">Preview</h2>
        <button className="gcd-modal-close" type="button" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <hr className="gcd-modal-divider" />
      <iframe
        className="gcd-preview-iframe"
        src={campaign.public_path}
        title={`Preview: ${campaign.name}`}
      />
    </div>
  </div>
);

export default PreviewModal;
